import styled from 'styled-components';

const SoldWrapper = styled.div`
  width: fit-content;
  margin: 5px 0;
  height: 27px;
`;

export { SoldWrapper };
